<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start" class="p-24">
    <form [formGroup]="certificationForm" *ngIf="!isLoading; else shimmer">
        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="32px">
            <div fxFlex="50" fxLayout="column">
                <app-certificate-taxonomy-fields
                    [providerControl]="certificationForm.get('provider')"
                    [certificationControl]="certificationForm.get('certification')"
                    (providerChange)="onProviderSelected($event)"
                    (certificationChange)="onCertificationSelected($event)"
                ></app-certificate-taxonomy-fields>

                <div class="w-100-p" fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="12px" fxLayoutAlign="space-between center">
                    <mat-form-field class="w-100-p">
                        <input
                            matInput
                            [matDatepicker]="issueDatePicker"
                            [min]="minIssueDate ? minIssueDate : null"
                            placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.ISSUE_DATE' | translate }}"
                            formControlName="issueDate"
                            (focus)="issueDatePicker.open()"
                            (ngModelChange)="updateExpirationDate()"
                        />
                        <mat-datepicker-toggle matSuffix [for]="issueDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #issueDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field class="w-100-p" *ngIf="selectedCertification?.hasExpirationDate">
                        <input
                            matInput
                            [matDatepicker]="expirationDatePicker"
                            [min]="minDate"
                            placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.EXPIRATION_DATE' | translate }}"
                            formControlName="expirationDate"
                            (focus)="expirationDatePicker.open()"
                        />
                        <mat-datepicker-toggle matSuffix [for]="expirationDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #expirationDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <mat-checkbox formControlName="notifyAboutExpiration" class="my-12" *ngIf="isToDoFeatureEnabled && selectedCertification?.hasExpirationDate">
                    {{ 'CERTIFICATE.NOTIFY_WHEN_IS_ABOUT_TO_EXPIRE' | translate }}
                </mat-checkbox>

                <mat-slide-toggle class="my-12" [formControl]="hasEndDate" (change)="onChangeEndDateToggle($event)" *ngIf="selectedCertification?.certificationName === 'other'">{{
                    'GENERAL.LABEL.HAS_END_DATE' | translate
                }}</mat-slide-toggle>

                <div class="p-24 bg-lightgreybackground" *ngIf="hasEndDate.value">
                    <mat-form-field class="w-100-p">
                        <input
                            matInput
                            [matDatepicker]="expirationDatePicker"
                            [min]="minDate"
                            placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.EXPIRATION_DATE' | translate }}"
                            formControlName="expirationDate"
                            (focus)="expirationDatePicker.open()"
                        />
                        <mat-datepicker-toggle matSuffix [for]="expirationDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #expirationDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-checkbox formControlName="notifyAboutExpiration" class="mt-12" *ngIf="isToDoFeatureEnabled">
                        {{ 'CERTIFICATE.NOTIFY_WHEN_IS_ABOUT_TO_EXPIRE' | translate }}
                    </mat-checkbox>
                </div>
            </div>

            <div fxFlex="50" fxLayout="column">
                <h2 class="mb-16 mt-0">{{ 'ALTERNATIVE.CERTIFICATE.SINGULAR' | translate }}</h2>
                <div
                    *ngIf="!uploadedCertificateFiles.length; else fileAdded"
                    class="file-drop-container certificates-list w-100-p h-188"
                    cdkDropList
                    (drop)="onFileDropped($event)"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    [class.drag-over]="isDragOver"
                >
                    <div>
                        <div fxLayout="column" fxLayoutAlign="center center">
                            <app-white-button class="my-12" [label]="'CONTENT.BUTTON.UPLOAD'" (onClick)="fileInput.click()" [showThreeDots]="true"></app-white-button>
                            <input
                                class="bg-white rounded-sm p-8 pointer border border-gray-300"
                                type="file"
                                style="display: none"
                                (change)="fileChange($event.target.files)"
                                [placeholder]="'CONTENT.BUTTON.UPLOAD' | translate"
                                accept=".pdf"
                                #fileInput
                            />
                            <p>{{ 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.DIALOGS.ADD_CERTIFICATE_TEMPLATE_TO_MODULE.LABELS.OR_DRAG_AND_DROP' | translate }}</p>
                        </div>
                    </div>
                </div>

                <ng-template #fileAdded>
                    <mat-card appearance="outlined">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <mat-icon class="mr-8">description</mat-icon>
                                <span>{{ uploadedCertificateFiles[0]?.name }}</span>
                            </div>
                            <mat-icon class="pointer" (click)="onRemoveAddedCertificate()">close</mat-icon>
                        </div>
                    </mat-card>
                </ng-template>
            </div>
        </div>
    </form>
    <ng-template #shimmer>
        <div class="shimmer-container p-0" fxLayout="row" fxLayoutAlign="flex-start space-between" fxLayoutGap="32px">
            <div class="shimmer w-100-p">
                <div class="shimmer-title max-w-60 mb-24 animate"></div>
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div class="shimmer-title max-w-sm mb-24 animate"></div>
            </div>

            <div class="shimmer w-100-p">
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div fxLayout="row wrap">
                    <div class="shimmer-card module animate" fxLayout="row" fxLayoutAlign="flex-start space-between" fxFlex="1 0 calc(100%-8px)"></div>
                </div>
            </div>
        </div>
    </ng-template>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="space-between center">
    <app-white-button [label]="'GENERAL.BUTTON.REPLACE_WITH_EXISTING' | translate" [svgIcon]="'replace'" (onClick)="openReplaceDialog()" *ngIf="certificate"></app-white-button>
    <div fxLayoutAlign="flex-end center" class="w-100-p">
        <div fxLayout="row" fxLayoutAlign="flex-start center" *ngIf="userId !== profile.id">
            <div
                class="info-icon"
                fxLayoutAlign="center center"
                matTooltip="{{ 'CERTIFICATE.TOOLTIP.CREATE_SILENTLY' | translate }}"
                aria-label="Info icon"
                matTooltipClass="tooltip"
            >
                i
            </div>
            <mat-checkbox [formControl]="createSilently" labelPosition="before" class="mr-24">
                {{ 'CERTIFICATE.CREATE_SILENTLY' | translate }}
            </mat-checkbox>
        </div>

        <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

        <app-flat-button
            [label]="certificate ? ('GENERAL.BUTTON.REPLACE' | translate) : ('GENERAL.BUTTON.SAVE' | translate)"
            (onClick)="saveSelected()"
            [disabled]="!certificationForm.valid"
            [isLoading]="isSaveButtonLoading"
        ></app-flat-button>
    </div>
</div>
